<template>
  <div class="refundability" v-b-popover.hover.top="refundable.tooltip">
    <vb-icon class="refundability__icon" :name="refundable.icon" :color="sass('gray-600')" :size="14" />
    <span class="refundability__text" :class="refundable.tooltip && 'underline'">{{ refundable.text }}</span>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'refundability',

  components: {
  },

  props: {
    cancellation: String,
  },

  data() {
    return {
    }
  },

  computed: {

    refundable() {
      const refundable = this.cancellation,
            formatted_date = refundable ? moment(refundable, 'DD-MM-YYYY HH:mm:ss Z').format('DD-MM-YYYY') : ''
      return {
        text: refundable ? `Cancellazione gratuita fino al ${formatted_date}` : 'Non rimborsabile',
        tooltip: !refundable ? 'La prenotazione non potrà essere cancellata nè modificata. Prenota quando sei sicuro del tuo viaggio' : '',
        icon: refundable ? 'check-circle' : 'lock_v2'
      }
    }

  },

  created() {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .refundability {
    display: flex;
    align-items: center;
    line-height: normal;

    &__text {
      font-weight: $vb-font-weight-semibold;
      cursor: default;
    }

    &__icon {
      display: none;

      @include media-breakpoint-up(sm){
        display: block;
        margin-top: 2px;
        margin-right: $grid-gutter-width / 6;
      }
    }
  }

</style>